import axios from 'axios';
import { useInfiniteQuery } from 'react-query';
import { useInitialProps } from '../context';
import { BriefsList } from '../../lib/types/brief';
import { BRIEFS_LIST_PAGE_SIZE } from '../../../configuration/constants';
import { BRIEFS_PAGINATED_LIST_QUERY_KEY } from '../components/shared/const';

const getBriefsList = (after?: string) =>
    axios
        .get<BriefsList>('/briefs/manage/api/list', { params: { after, pageSize: BRIEFS_LIST_PAGE_SIZE } })
        .then((res) => res.data);

export const usePaginatedBriefsList = () => {
    const { briefsList: initialData } = useInitialProps();
    const { data, refetch, isLoading, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
        queryKey: BRIEFS_PAGINATED_LIST_QUERY_KEY,
        queryFn: ({ pageParam }) => getBriefsList(pageParam),
        getNextPageParam: (lastPage) => (lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : false),

        ...(initialData ? { initialData: { pages: [initialData], pageParams: [undefined] } } : {}),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    const totalCount = data ? data?.pages?.[0]?.totalCount : 0;

    const briefsList = data?.pages.flatMap((page) => page.nodes) || [];

    return {
        briefsList,
        totalCount,
        hasBriefs: !!briefsList.length,
        refetch,
        fetchNextPage,
        isLoading,
        isError,
        hasNextPage,
    };
};
